import React from "react";
import { ContentStatsListLoaderTemplate } from "themes/administration/analytics/components";

function ContentStatsListLoader(props) {
    return <ContentStatsListLoaderTemplate {...props} />;
}

export default ContentStatsListLoader;
